import classNames from "classnames";

import { ArrowLeft } from "@/components/icons";

import styles from "./GoUpButton.module.scss";

interface GoUpButtonProps {
  className?: string;
  onClick?(): void;
}

const GoUpButton = ({ className, onClick }: GoUpButtonProps) => {
  return (
    <button className={classNames(styles.root, className)} onClick={onClick}>
      <ArrowLeft color="#FFFFFF" />
    </button>
  );
};

export default GoUpButton;
